const slider = require('../../actions/order/slider');

module.exports = {
    sliderNextView: [
        slider.asyncAnimation, {
            no: [
                slider.sliderNextView
            ]
        }
    ]
};



// WEBPACK FOOTER //
// ./signals/order/slider.js